import { createRgAPI } from '~/api/core/rgRequest';

export const acceptTerms = async () => {
  try {
    await createRgAPI('/set_uzer_terms').post();

    return 'ok';
  } catch (e) {
    return Promise.reject(e);
  }
};
